import DataTable from "../components/UI/DataTable/DataTable";
import TablePage from "./TablePage";

export default function EpcData() {
	return (
		<TablePage title="Data">
			<DataTable />
		</TablePage>
	);
}
